import { parseAppointmentDateTime } from './appointment-display';

const DEFAULT_EVENT_DURATION_MINUTES = 60;

const toGoogleUtcDate = (date: Date): string => {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getUTCFullYear()}${pad(date.getUTCMonth() + 1)}${pad(date.getUTCDate())}T${pad(date.getUTCHours())}${pad(date.getUTCMinutes())}${pad(date.getUTCSeconds())}Z`;
};

export interface GoogleCalendarEventOptions {
  title: string
  startDateTime: string
  durationMinutes?: number
  description?: string
  location?: string
}

export const buildGoogleCalendarEventUrl = (
  options: GoogleCalendarEventOptions,
): string | null => {
  const start = parseAppointmentDateTime(options.startDateTime);
  if (!start) return null;

  const durationMinutes = options.durationMinutes ?? DEFAULT_EVENT_DURATION_MINUTES;
  const end = new Date(start.getTime() + durationMinutes * 60 * 1000);

  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: options.title,
    dates: `${toGoogleUtcDate(start)}/${toGoogleUtcDate(end)}`,
  });

  if (options.description) {
    params.set('details', options.description);
  }
  if (options.location) {
    params.set('location', options.location);
  }

  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export const openGoogleCalendarEvent = (options: GoogleCalendarEventOptions): void => {
  const url = buildGoogleCalendarEventUrl(options);
  if (!url) return;
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const buildAdhdIntakeCalendarEvent = (
  startDateTime: string,
  clinicianName?: string,
): GoogleCalendarEventOptions => ({
  title: clinicianName
    ? `ADHD Intake Assessment — ${clinicianName}`
    : 'ADHD Intake Assessment',
  startDateTime,
  description: 'Your clinician will review everything before the session. We\'ll text your telehealth link 48 hours before.',
});
